import React, { createContext, useContext, useState, useEffect } from 'react';
import { usePlan } from './PlanContext';

const ModeContext = createContext({ mode: 'operate', setMode: () => {} });

export const useMode = () => useContext(ModeContext);

export const ModeProvider = ({ children }) => {
  const { plan: tier, loading: planLoading } = usePlan();
  const isPartnerPro = tier === 'partner-pro' || tier === 'partner_pro';

  const [mode, setModeState] = useState(() => {
    if (typeof window === 'undefined') return 'operate';
    const saved = localStorage.getItem('mm_ui_mode');
    return saved === 'design' ? 'design' : 'operate';
  });

  // Non-partner-pro users are always locked to operate
  // IMPORTANT: Only run this effect after plan is loaded to avoid clearing localStorage prematurely
  useEffect(() => {
    if (planLoading) return; // Wait for plan to load before enforcing restrictions
    if (!isPartnerPro && mode === 'design') {
      setModeState('operate');
      localStorage.removeItem('mm_ui_mode');
    }
  }, [isPartnerPro, mode, planLoading]);

  const setMode = (newMode) => {
    if (!isPartnerPro) return;
    const val = newMode === 'design' ? 'design' : 'operate';
    setModeState(val);
    localStorage.setItem('mm_ui_mode', val);
  };

  return (
    <ModeContext.Provider value={{ mode: isPartnerPro ? mode : 'operate', setMode, canToggle: isPartnerPro }}>
      {children}
    </ModeContext.Provider>
  );
};
